import React from 'react';
import TextCell from './TextCell';
import NumberCell from './NumberCell';
import DateCell from './DateCell';
import TimeCell from './TimeCell';
import SelectCell from './SelectCell';
import CheckboxCell from './CheckboxCell';
import UserCell from './UserCell';
import ReferenceCell from './ReferenceCell';
import FormatCell from './FormatCell';
import FileCell from './FileCell';
import SignatureCell from './SignatureCell';
import RichTextCell from './RichTextCell';
import DynamicFieldCell from './DynamicFieldCell';
import ReadOnlyCell from './ReadOnlyCell';
import UrlCell from './UrlCell';
import MatrixCell from './MatrixCell';
import SubformCell from './SubformCell';
import EditorWrapper from '../editors/EditorWrapper';
import TextEditor from '../editors/TextEditor';
import NumberEditor from '../editors/NumberEditor';
import DateEditor from '../editors/DateEditor';
import TimeEditor from '../editors/TimeEditor';
import SelectEditor from '../editors/SelectEditor';
import CheckboxEditor from '../editors/CheckboxEditor';
import RichTextEditor from '../editors/RichTextEditor';
import FormatEditor from '../editors/FormatEditor';

const CELL_MAP = {
  answer_string: TextCell,
  email: TextCell,
  answer_integer: NumberCell,
  answer_formula: NumberCell,
  answer_date: DateCell,
  answer_time: TimeCell,
  answer_hour: TimeCell,
  answer_select: SelectCell,
  answer_radio: SelectCell,
  answer_checkbox: CheckboxCell,
  answer_user_id: UserCell,
  proceso_id: ReferenceCell,
  position_id: ReferenceCell,
  format_id: FormatCell,
  answer_file: FileCell,
  answer_signature: SignatureCell,
  answer_text: RichTextCell,
  dynamic_field: DynamicFieldCell,
  code_format: ReadOnlyCell,
  answer_autdatetime: ReadOnlyCell,
  localization: ReadOnlyCell,
  url: UrlCell,
  answer_matrix: MatrixCell,
  answer_subform: SubformCell,
};

function editorForType(type, cell, column, onSave, onCancel, users, procesos, positions, froalaConfig) {
  const commonProps = { value: cell.v, column, onSave, onCancel };

  switch (type) {
    case 'answer_string':
    case 'email':
    case 'url':
      return <TextEditor {...commonProps} />;
    case 'answer_integer':
    case 'answer_formula':
      return <NumberEditor {...commonProps} />;
    case 'answer_date':
      return <DateEditor {...commonProps} />;
    case 'answer_time':
    case 'answer_hour':
      return <TimeEditor {...commonProps} />;
    case 'answer_select':
    case 'answer_radio':
      return <SelectEditor {...commonProps} />;
    case 'answer_checkbox':
      return <CheckboxEditor {...commonProps} />;
    case 'answer_text':
      return <RichTextEditor {...commonProps} froalaConfig={froalaConfig} />;
    case 'answer_user_id':
      return <SelectEditor {...commonProps} options={(users || []).map(u => ({ label: u.name, value: u.id.toString() }))} />;
    case 'proceso_id':
      return <SelectEditor {...commonProps} options={(procesos || []).map(p => ({ label: p.name, value: p.id.toString() }))} />;
    case 'position_id':
      return <SelectEditor {...commonProps} options={(positions || []).map(p => ({ label: p.name, value: p.id.toString() }))} />;
    case 'format_id':
      return <FormatEditor {...commonProps} />;
    default:
      return <TextEditor {...commonProps} />;
  }
}

export default function CellRenderer({
  cell, column, isEditing, onStartEdit, onCancel, onSave,
  users, procesos, positions, froalaConfig, formato, format_category
}) {
  if (isEditing) {
    return (
      <EditorWrapper onSave={() => {}} onCancel={onCancel}>
        {editorForType(column.type, cell, column, onSave, onCancel, users, procesos, positions, froalaConfig)}
      </EditorWrapper>
    );
  }

  const Component = CELL_MAP[column.type] || ReadOnlyCell;

  return (
    <div className={column.editable ? 'cm-cell-clickable' : ''} onDoubleClick={column.editable ? onStartEdit : undefined}>
      <Component
        value={cell.v}
        style={cell.s}
        color={cell.color}
        checkTest={cell.ct}
        column={column}
        cell={cell}
        formato={formato}
        format_category={format_category}
      />
    </div>
  );
}
